var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"white"},style:({ 'pointer-events': !_vm.gesture ? 'auto' : 'none' }),attrs:{"id":"parallaxscrolling"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.isamnet}}),_c('div',{attrs:{"id":"ucf-content"}},[_c('div',{attrs:{"id":"main-wrapper"}},[_c('div',{attrs:{"id":"main-container"}},[_c('div',{staticClass:"ucf-carousel-wrapper",staticStyle:{"overflow":"hidden"}},[_c('div',{staticClass:"ucf-carousel-container",style:({
              width: (_vm.imageAreaW + "px"),
              margin: 'auto',
              background: 'black',
              position: 'relative',
            })},[_vm._l((_vm.creative.images),function(image,index){return _c('div',{key:index,class:['item'],style:({
                width: (_vm.imageAreaW + "px"),
                height: (_vm.imageAreaH + "px"),
                zIndex: ("" + ((_vm.creative.images.length + 10) - index)),
                overflow: 'hidden',
                position: 'relative',
              })},[(image.material_type === _vm.CONSTANT.MATERIAL_TYPE.IMAGES)?_c('a',{style:({
                  width: (_vm.imageW + "px"),
                  height: (_vm.imageH + "px"),
                }),attrs:{"href":_vm.creative.landing_page,"target":"_blank"}},[_c('img',{style:({
                    width: (_vm.imageW + "px"),
                    height: (_vm.imageH + "px"),
                    position: "absolute",
                    bottom: "0px",
                    left: "50%",
                    transform: "translateX(-50%)"
                  }),attrs:{"src":image.url}})]):_vm._e(),(image.material_type === _vm.CONSTANT.MATERIAL_TYPE.HTML)?_c('div',{staticClass:"overlay-iframe",style:({
                  width: (_vm.imageW + "px"),
                  height: (_vm.imageH + "px"),
                  position: "absolute",
                  bottom: "0px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  zIndex: 1,
                }),on:{"click":_vm.openLandingPage}}):_vm._e(),(image.material_type === _vm.CONSTANT.MATERIAL_TYPE.HTML)?_c('div',{style:({
                  width: (_vm.imageW + "px"),
                  height: (_vm.imageH + "px"),
                  position: "absolute",
                  bottom: "0px",
                  left: "50%",
                  transform: "translateX(-50%)"
                })},[(image.material_type === _vm.CONSTANT.MATERIAL_TYPE.HTML)?_c('iframe',{class:("h5-" + index),style:({
                  margin: '0',
                  border: 'none',
                  overflow: 'hidden',
                  display: 'block',
                  backgroundColor: 'black',
                  width: '320px',
                  height: '400px',
                  transformOrigin: '0 0',
                  transform: ("scale(" + _vm.iframeScale + ")"),
                }),attrs:{"src":image.url,"scrolling":"no","frameborder":"0","allowfullscreen":"true"}}):_vm._e()]):_vm._e()])}),_c('div',{style:({
                width: "100%",
                height: (_vm.videoHeight + "px"),
                transform: ("translateY(" + _vm.videoTranslateY + "px)"),
                zIndex: "1000 !important",
                position: "relative",
              }),attrs:{"id":"ucf-video-container"}})],2)])])])]),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"https://cdn.aralego.net/rich_media/assets/parallaxScrolling/bg2.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }